var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mm-page mm-slideout",attrs:{"id":"mm-0"}},[_c('div',{attrs:{"id":"page"}},[_c('TheHeader'),_c('router-view')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"toTop"}},[_c('i',{staticClass:"bi bi-chevron-up"})])
}]

export { render, staticRenderFns }